var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contact",attrs:{"href":_vm.link,"aria-label":_vm.contactAriaLabel,"target":"_blank"}},[(_vm.contactPhotoFromBase64)?_c('img',{class:{
			'contact__image': _vm.contactHasPhoto,
			'contact__icon': !_vm.contactHasPhoto,
		},attrs:{"alt":"","src":_vm.contactPhotoFromBase64}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"contact__lineone"},[_c('div',{staticClass:"title"},[_vm._v("\n\t\t\t"+_vm._s(_vm.displayName)+"\n\t\t")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }